import React from "react";

import styles from "../../styles/order-details.module.scss";
import { Currency } from "../utils/Currency";
import { OMath } from "../utils/OMath";

// import { convertMoney } from "../utils";

const DeliveryType = {
  DELIVER_ON_ADDRESS: 1,
  GET_ON_PLACE: 2,
  INDOOR: 2,
};

const GIFT_TYPE = {
  // ===== Valores adicioniais =====
  ADDITION: 1,

  // ===== Forma de cobrança =====
  PRICE: 2,
  PERCENT: 4,

  // ===== Cobrar com base em =====
  CART: 8,
  DELIVERY: 16,

  // ===== Tipo de uso do cupom =====
  FIRST_PURCHASE_EVER: 32,
  N_USE: 64,
  FREE_TO_USE: 128,
  NEXT_PURCHARSE: 256,
  CASHBACK_USE: 512,
  CASHBACK_EARN: 1024,
  PRODUCT: 2048,
};

export default class Totals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  typeIs(giftType, type) {
    return (giftType & type) == type;
  }

  getGiftType(gift) {
    const programByPoint =
      localStorage.getItem("cashbackProgramType") === "POINT";

    if ((gift.type & GIFT_TYPE.CASHBACK_USE) === GIFT_TYPE.CASHBACK_USE)
      return "Desconto (Cashback)";

    if ((gift.type & GIFT_TYPE.CASHBACK_EARN) === GIFT_TYPE.CASHBACK_EARN) {
      if (programByPoint) return `Pontos concebidos`;
      return `Cashback concebido`;
    }

    return `Desconto (${gift.code?.split("-")?.[0]})`;
  }

  executeOnSchema(item, callback) {
    for (let field of [
      "items",
      "extra_ingredients",
      "edges",
      "doughs",
      "sizes",
    ]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          this.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  calculateItemPrice(item) {
    const props = ["items", "sizes", "extra_ingredients", "doughs", "edges"];
    let total = item.price;

    for (const key of props) {
      if (item[key] && item[key].length > 0) {
        for (const subItem of item[key]) {
          total += this.calculateItemPrice(subItem);
        }
      }
    }

    return total * item.quantity;
  }

  getLastPartSku(sku) {
    let parts;
    let lastPart;

    if (sku) {
      parts = sku?.split("#");
      lastPart = parts[parts.length - 1];
    }

    return lastPart || "";
  }

  getProductDiscountValue(gift, cartItems = []) {
    if (!this.typeIs(gift?.type, GIFT_TYPE.PRODUCT)) {
      return 0;
    }

    if (!gift?.target_id) {
      return 0;
    }

    const targetId = Array.isArray(gift.target_id)
      ? gift.target_id
      : [gift.target_id];
    let baseValue = 0;

    for (let i = 0; i < cartItems.length; i++) {
      let productPrice = null;
      const product = JSON.parse(JSON.stringify(cartItems[i]));

      if (targetId.includes(this.getLastPartSku(product.sku))) {
        productPrice = product.price;
      }

      this.executeOnSchema(product, (item, parent) => {
        if (
          item.type === "size" &&
          parent &&
          parent.quantity &&
          (parent.items?.length || parent.sizes?.length)
        ) {
          const parentPrice = this.calculateItemPrice(parent);
          productPrice += OMath.div(parentPrice, parent.quantity);
        } else if (item.price) {
          productPrice += item.price * item.quantity;
        } else {
          productPrice = this.calculateItemPrice(item);
        }
      });

      if (productPrice !== null && !Number.isNaN(productPrice)) {
        baseValue = productPrice;
        break;
      }
    }

    return baseValue;
  }

  getValue(gift, cartValue, deliveryValue = 0, cartItems = []) {
    const programByPoint =
      localStorage.getItem("cashbackProgramType") === "POINT";

    let baseValue = this.typeIs(gift.type, GIFT_TYPE.DELIVERY)
      ? deliveryValue
      : this.typeIs(gift.type, GIFT_TYPE.CART)
      ? cartValue
      : this.typeIs(gift.type, GIFT_TYPE.PRODUCT)
      ? this.getProductDiscountValue(gift, cartItems)
      : 0;
    let v = gift.value || 0;
    let finalGiftValue = 0;

    if (this.typeIs(gift.type, GIFT_TYPE.PERCENT)) {
      finalGiftValue = (baseValue * Math.min(v, 100)) / 100;
    } else if (this.typeIs(gift.type, GIFT_TYPE.PRICE)) {
      finalGiftValue = !this.typeIs(gift.type, GIFT_TYPE.ADDITION)
        ? Math.min(baseValue, v)
        : v;
    }

    if (programByPoint && this.typeIs(gift.type, GIFT_TYPE.CASHBACK_EARN))
      return `${finalGiftValue} pts`;

    return Currency.formatCurrency(
      +(
        Math.abs(finalGiftValue) *
        (this.typeIs(gift.type, GIFT_TYPE.ADDITION) ||
        this.typeIs(gift.type, GIFT_TYPE.CASHBACK_EARN)
          ? 1
          : -1)
      )
    );
  }

  render() {
    const { order } = this.props;
    const { delivery, cart, payment, total, gift } = order;

    return (
      <div className={styles.totals}>
        <div className={styles.item}>
          <p>Valor do pedido</p>
          <span className={styles.value}>
            {Currency.formatCurrency(cart.total)}
          </span>
        </div>
        {delivery.type == DeliveryType.DELIVER_ON_ADDRESS && (
          <div className={styles.item}>
            <p>Taxa de entrega</p>
            <span className={styles.value}>
              {!delivery.total
                ? "Grátis"
                : Currency.formatCurrency(delivery.total)}
            </span>
          </div>
        )}
        {gift && (
          <div className={styles.item}>
            <p>{this.getGiftType(gift)}</p>
            <span className={styles.value}>
              {gift?.code &&
              (gift.type & GIFT_TYPE.CASHBACK_EARN) ===
                GIFT_TYPE.CASHBACK_EARN ? (
                <strong>({gift?.code})</strong>
              ) : (
                ""
              )}
              {this.getValue(
                gift,
                cart.total,
                delivery.total,
                cart?.catalog?.items
              )}
            </span>
          </div>
        )}

        <div className={styles.total}>
          <p>VALOR TOTAL</p>
          <span className={styles.value}>{Currency.formatCurrency(total)}</span>
        </div>
      </div>
    );
  }
}
